import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { FCM_PETITION_PAGE_CONTACT_DM } from 'src/app/shared/fcm/configs';

export async function getContactDmConfig(utilityContext: UtilityContext): Promise<{
	emailSubjectLine: string;
	emailBody: readonly string[];
	emailEnabled: boolean;
}> {
	const { contactDmConfig } = await utilityContext.fcm.get({ contactDmConfig: FCM_PETITION_PAGE_CONTACT_DM });

	return {
		emailSubjectLine: contactDmConfig?.emailSubjectLine || '',
		emailBody: contactDmConfig?.emailBody || [''],
		emailEnabled: !!contactDmConfig?.emailEnabled,
	};
}
